<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";
	import Chip from "../Chip.svelte";

	export let values = []
	export let klass: string = ''
	export let focus : boolean = false
	export let isError: boolean = false
	export let options = []
	let element

	const dispatch = createEventDispatcher()

	function input(e: any) {
		dispatch('input', {
			value: e.target.value
		})
	}

	function keypress(e: any) {
		dispatch('keypress', {
			value: e.charCode
		})
	}

	onMount(() => {
		if (focus) {
			element.focus()
		}
	})
</script>

<select
	value={values}
	class="input-select {klass}"
	class:is-error={isError}
	on:input={input}
	on:keypress={keypress}
	bind:this={element}
>
	<option value="0">
		未選択
	</option>
	{#each options as o(o.id)}
		<option value={o.id}>
			{ o.label }
		</option>
	{/each}
</select>

<div class="mt-2">
	{#each values as v, i}
		{#if i === 0}
			<Chip label="{v.label}" close={v.close}/>
		{:else}
			<Chip label="{v.label}" close={v.close} klass="ml-1" />
		{/if}
	{/each}
</div>

<style lang="postcss">
	.input-select {
		@apply p-3 w-full text-sm bg-white;
	}
	.input-select:focus {
		@apply outline-none border-blue-400;
	}
	.is-error {
		@apply outline-none border-red-400;
	}
</style>